const BLOCKED_REDIRECT_PREFIXES = ['/auth/signin', '/onboarding'];

export const getCurrentRedirectPath = (): string =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;

export const sanitizeRedirect = (redirect?: string | null): string | null => {
  if (!redirect) return null;

  const value = redirect.trim();
  if (!value) return null;

  let path = value;

  if (value.startsWith('http://') || value.startsWith('https://')) {
    const url = new URL(value);

    if (url.origin !== window.location.origin) {
      return null;
    }

    path = `${url.pathname}${url.search}${url.hash}`;
  }

  if (!path.startsWith('/') || path.startsWith('//')) {
    return null;
  }

  const lowerPath = path.toLowerCase();

  const isBlocked = BLOCKED_REDIRECT_PREFIXES.some((blockedPrefix) =>
    lowerPath.startsWith(blockedPrefix),
  );

  if (isBlocked) {
    return null;
  }

  return path;
};
